import React, { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Table, Spin, Modal, Tooltip } from "antd";
import { connect } from "react-redux";
import { Grid, Button } from "@mui/material";
import { IoMdAddCircle } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import AddActivityDrawerRight from "components/drawer/AddActivityDrawer";
import { EditOutlined } from "@ant-design/icons";
import { dispatch } from "store/index";
import { FetchAllActivitiesOfCamp, ExportCampaignActivityReport, GetLogsActivityStats, CreateBulkUploader, DeleteAllActivities, FetchActivityReportSpecific, FetchingActivityStatsReps } from "store/action/index";
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from "xlsx";
import { IoIosCall } from "react-icons/io";
import { CiExport } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { MdOutlineSms } from "react-icons/md";
import moment from "moment";
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { TbEyeCog } from "react-icons/tb";
import { GiCardJackClubs } from "react-icons/gi";
import { FaRobot } from "react-icons/fa6";
import {
  can_add_activities,
  can_view_activities,
  can_edit_activities,
} from "helper/permissionsCheck";
import CsvUploadByofllineCall from '../../components/inputs/csvUploadOfflineCall'

const AllCampaigns = ({ allActivities, campaignActExpData, allActivitiesstatslogs, alldataactnote, statscallactivitydata }) => {
  const [loading, setLoading] = useState(true);
  const [loadingE, setELoading] = useState(true);
  const [campaignSeetinId, setCampaig_seeting_Id] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [excelSLoading, setExcelSLoading] = useState(false);
  const [excelAgentLsoading, setExcelAgentLoading] = useState(false);
  const [downloadCond, setDownLoadCondition] = useState(false);
  const [downloadsCond, setDownLosadCondition] = useState(false);
  const [downloadagentCond, setDownLoadAgentCondition] = useState(false);
  const [fileName, setFileName] = useState('');
  const [fileNameActStats, setFileNameActStats] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [statsactstatsrepdownconditions, setStatsRepoDownConditions] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  let params = { team_id: localStorage.getItem("teams_id") }

  useEffect(() => { console.log("activitystatsReport", statscallactivitydata) }, [statscallactivitydata])

  const activityRoutes = {
    SMS: '/activities/edit-sms-activity',
    Call: '/activities/edit-call-activity',
    Email: '/activities/edit-email-activity',
    WhatsApp: '/activities/edit-whatsapp-activity',
  }
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Type",
      dataIndex: "id",
      key: "id",
      render: (text, record) => (
        <span>
          {record?.activities?.id == 2 ? (
            <IoIosCall style={{ fontSize: "22px" }} />
          ) : record?.activities?.id == 3 ? (
            <FaWhatsapp style={{ fontSize: "22px" }} />
          ) : record?.activities?.id === 5 ? (
            <MdEmail style={{ fontSize: "22px" }} />
          ) : record?.activities?.id == 4 ? (
            <MdOutlineSms style={{ fontSize: "22px" }} />
          ) : record?.activities?.id == 6 ? (
            <FaRobot style={{ fontSize: "22px" }} />) : (
            ""
          )}
        </span>
      ),
    },
    can_edit_activities || can_view_activities ? {
      title: "Actions",
      key: "action",
      render: (text, record) => {
        return (
          <>
            <Button
              type="text"
              style={{ color: "#1890ff" }}
              onClick={() => handleEdit(record)}
            >
              {record?.status == 4 ? (
                <TbEyeCog style={{ fontSize: "18px" }} />
              ) : record?.status !== 1 ? (
                <EditOutlined style={{ fontSize: "18px" }} />
              ) : (
                <TbEyeCog style={{ fontSize: "18px" }} />
              )}
            </Button>
            {record?.activity_id == "2" ? <Tooltip title="Activity Report">
              <Button
                type="text"
                style={{ color: "#1890ff" }}
                onClick={() => HandleDownreport(record)}
              >
                <DownloadIcon />
              </Button>
            </Tooltip> : null}
            {record?.activity_id == "2" ? <Tooltip title="Activity Stats Report">
              <Button
                type="text"
                style={{ color: "#1890ff" }}
                onClick={() => HandleDownloadReportActivityStats(record)}
              >
                <DownloadIcon />
              </Button>
            </Tooltip> : null}

            {record?.activities?.id !== 2 && record?.status == "1" || record?.status == "0" ? < Button
              type="text"
              style={{ color: "#1890ff" }}
              onClick={() => handleDelete(record)}
            >
              <MdDelete />
            </Button > : null}
          </>
        );
      },
    } : null
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setELoading(true);
    const transformedDataSource = dataSource.map(item => ({
      ...item,
      date_time: moment(item.date_time, 'M/D/YYYY H:mm').format('YYYY-MM-DD HH:mm:ss'),
      activity_setting_id: campaignSeetinId
    }));
    let fieldDataFormat = { data: transformedDataSource };

    dispatch(CreateBulkUploader({ fieldData: fieldDataFormat, setELoading: setELoading, params }));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleEdit = (record) => {
    if (record?.activity_id == "6") {
      setCampaig_seeting_Id(record?.id)
      showModal();
      return;
    }
    navigate(activityRoutes[record?.activities?.name], {
      state: {
        data: {
          ...location?.state,
          ...record,
          ...allActivities,
          activity_id_specific: record?.id,
          records: record,
          sepcific_activity_id: location.state?.id,
        },
      },
    });
  };

  const HandleDownreport = (record) => {
    setDownLoadCondition(false)
    setFileName(record?.name)
    setLoading(true)
    let paramsss = { team_id: localStorage.getItem("teams_id"), activity_setting_id: record?.id }
    dispatch(FetchActivityReportSpecific({ setLoading: setLoading, setDownLoadCondition, params: paramsss }));
  }

  const HandleDownloadReportActivityStats = (record) => {
    setStatsRepoDownConditions(false)
    setFileNameActStats(record?.name)
    setLoading(true)
    let paramsss = { team_id: localStorage.getItem("teams_id"), activity_setting_id: record?.id }
    dispatch(FetchingActivityStatsReps({ setLoading: setLoading, setDownLoadCondition: setStatsRepoDownConditions, params: paramsss }));
  }

  const handleDelete = (record) => {
    setLoading(true)
    dispatch(DeleteAllActivities({ alldata: record, setLoading: setLoading, params }));
  }

  useEffect(() => {
    let paramss = { team_id: localStorage.getItem("teams_id"), leads: 0 }
    dispatch(FetchAllActivitiesOfCamp({ id: location.state?.id, setLoading: setLoading, params: paramss }));
  }, []);

  const exportExcel = () => {
    const formattedData = (Array.isArray(campaignActExpData?.data) ? campaignActExpData?.data : []).map((log) => ({
      "Agent Name": log?.agent_name || "",
      "Call Attempted": log?.attempted_count || "",
      "Calls Connected": log?.connected_calls || "",
      "Total Duration Min": log?.total_duration || "",
      "Avg Duration per Call": log?.avg_duration || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SmsLogs");
    XLSX.writeFile(workbook, "AgentStatsCmapignReport.xlsx");
  };

  const exportExcelByActvityStatsOne = () => {
    if (!statscallactivitydata || typeof statscallactivitydata !== "object") return;
    const { connected_calls, total_leads, total_questions, answer_counts } = statscallactivitydata;

    const baseRow = {
      "Connected Call": connected_calls || "",
      "Total Leads": total_leads || "",
    };

    const formattedData = [];

    const questionAnswers = total_questions.map((q) => {
      const answersWithTotals = answer_counts
        .filter((a) => a.question_id === q.id)
        .map((a) => {
          let cleanAnswer = a.answer;
          if (Array.isArray(cleanAnswer)) {
            cleanAnswer = cleanAnswer[0] || "";
          }
          if (typeof cleanAnswer === 'string') {
            cleanAnswer = cleanAnswer.replace(/^\["?|"?\]$/g, '').replace(/^"|"$/g, '');
          }
          return {
            answer: cleanAnswer,
            total: a.total || 0,
          };
        });
      return { question: q.question, answers: answersWithTotals };
    });

    const maxRows = Math.max(...questionAnswers.map((qa) => qa.answers.length));

    for (let i = 0; i < maxRows; i++) {
      const newRow = {};
      if (i === 0) {
        newRow["Connected Call"] = baseRow["Connected Call"];
        newRow["Total Leads"] = baseRow["Total Leads"];
      } else {
        newRow["Connected Call"] = "";
        newRow["Total Leads"] = "";
      }

      questionAnswers.forEach((qa, index) => {
        const answerData = qa.answers[i] || { answer: "", total: 0 };
        newRow[qa.question] = answerData.answer;
        if (answerData.total > 0) {
          newRow[`Total_${index}`] = answerData.total; // Unique key with index
        }
      });
      formattedData.push(newRow);
    }

    if (formattedData.length === 0) {
      const emptyRow = { ...baseRow };
      total_questions.forEach((q) => {
        emptyRow[q.question] = "";
      });
      for (let i = 0; i < total_questions.length; i++) {
        emptyRow[`Total_${i}`] = "";
      }
      formattedData.push(emptyRow);
    }

    const headers = Object.keys(formattedData[0] || baseRow);
    const newHeaders = headers.map(header => {
      if (header.startsWith("Total_")) return "Total"; // Display as "Total"
      return header;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers }); // Use original headers for unique columns
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (worksheet[cellAddress] && worksheet[cellAddress].v && worksheet[cellAddress].v.startsWith("Total_")) {
        worksheet[cellAddress].v = "Total"; // Change displayed header to "Total"
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ActivityStats");
    const finalFileName = (fileNameActStats || "Activity") + "StatsReport.csv";
    XLSX.writeFile(workbook, finalFileName);
  };

  const exportLExcel = () => {
    const formattedData = (Array.isArray(allActivitiesstatslogs) ? allActivitiesstatslogs : []).map((log) => ({
      "Activity Name": log?.activity_name || "",
      "Total Batches": log?.total_batches || "",
      "Unique Leads": log?.total_leads || "",
      "Activities": log?.executed || "",
      "Connected": log?.connected || "",
      "Responded": log?.connected || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SmsLogs");
    XLSX.writeFile(workbook, "ActivitiesStatsReport.xlsx");
  };

  const exportActvitiesExcel = () => {
    let questions = alldataactnote?.question || [];

    const formattedData = (Array.isArray(alldataactnote?.leads) ? alldataactnote?.leads : []).map((log) => {
      let row = {
        "Lead Name": log?.name || "",
        "Phone": log?.phone || "",
        "Email": log?.email || "",
        "Notes": Array.isArray(log?.filtered_notes)
          ? log.filtered_notes.map(e => e?.note).filter(Boolean).join(", ")
          : "--",
        "Notes Added By": Array.isArray(log?.filtered_notes)
          ? log.filtered_notes.map(e => e?.user_name).filter(Boolean).join(", ")
          : "--",
        "Total Calls Initiated": Array.isArray(log?.activities)
          ? log.activities.reduce((acc, activity) => {
            if (Array.isArray(activity?.call_logs_activity)) {
              const callCount = activity.call_logs_activity.filter(
                (logItem) => logItem?.call_status == "Calling"
              ).length;
              acc += callCount;
            }
            return acc;
          }, 0)
          : 0,

        "Total Connected Calls": Array.isArray(log?.activities)
          ? log.activities.reduce((acc, activity) => {
            if (Array.isArray(activity?.call_logs_activity)) {
              const callCount = activity.call_logs_activity.filter(
                (logItem) => logItem?.call_status == "Established"
              ).length;
              acc += callCount;
            }
            return acc;
          }, 0)
          : 0,
        "Call Started On": Array.isArray(log?.activities)
          ? log.activities.flatMap((activity) =>
            Array.isArray(activity?.call_logs_activity)
              ? activity.call_logs_activity
                .filter((logItem) => logItem?.call_status == "Calling" && logItem?.call_started_on)
                .map((logItem) =>
                  new Date(logItem.call_started_on).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit", // ✅ Added seconds
                    hour12: true,
                  })
                )
              : []
          ).join(", ")
          : "--",
        "Call Established": Array.isArray(log?.activities)
          ? log.activities.flatMap((activity) =>
            Array.isArray(activity?.call_logs_activity)
              ? activity.call_logs_activity
                .filter((logItem) => logItem?.call_status == "Established" && logItem?.call_started_on)
                .map((logItem) =>
                  new Date(logItem.call_started_on).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit", // ✅ Added seconds here too
                    hour12: true,
                  })
                )
              : []
          ).join(", ")
          : "--",
        "Call Terminated": Array.isArray(log?.activities)
          ? log.activities.flatMap((activity) =>
            Array.isArray(activity?.call_logs_activity)
              ? activity.call_logs_activity
                .filter((logItem) => logItem?.call_status == "Terminated" && logItem?.call_ended_on)
                .map((logItem) =>
                  new Date(logItem.call_ended_on).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit", // ✅ Added seconds here too
                    hour12: true,
                  })
                )
              : []
          ).join(", ")
          : "--",
        "Call Duration": Array.isArray(log?.activities)
          ? log.activities.flatMap((activity) =>
            Array.isArray(activity?.call_logs_activity)
              ? activity.call_logs_activity
                .filter((logItem) => logItem?.call_status == "Terminated" && logItem?.call_duration)
                .map((logItem) => logItem.call_duration)
              : []
          ).join(", ")
          : "--",
        "Agent Name": Array.isArray(log?.activities)
          ? log.activities.flatMap((activity) =>
            Array.isArray(activity?.call_logs_activity)
              ? activity.call_logs_activity
                .filter((logItem) => logItem?.call_status == "Calling" && logItem?.user?.name)
                .map((logItem) => logItem.user.name)
              : []
          ).join(", ")
          : "--",
        "Activity Status": Array.isArray(log?.activities)
          ? log.activities
            .map(activity => activity?.activity_action)
            .filter(Boolean) // remove undefined/null
            .join(", ")
          : "--"
      };

      questions.forEach((q) => {
        row[q?.question] = "";
      });

      log.answers?.forEach(answerObj => {
        let matchedQuestion = questions?.find(q => q.id == answerObj?.question_id);
        if (matchedQuestion) {
          let answerValue = Array.isArray(answerObj?.answer) ? answerObj?.answer.join(", ") : answerObj?.answer || "";
          row[matchedQuestion?.question] = answerValue;
        }
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SmsLogs");
    const finalFileName = (fileName || "") + " ActvityReport.xlsx";
    XLSX.writeFile(workbook, finalFileName);
  };

  useEffect(() => {
    if (downloadCond && Array.isArray(alldataactnote?.leads) && Array.isArray(alldataactnote?.question) && alldataactnote?.leads?.length !== 0) {
      exportActvitiesExcel();
    }
  }, [downloadCond, alldataactnote])

  const HandleDownreportTopLogs = () => {
    setDownLosadCondition(false)
    setExcelSLoading(true)
    let patamsmms = { team_id: localStorage.getItem("teams_id"), campaign_id: location?.state?.id }
    dispatch(GetLogsActivityStats({ setExcelSLoading: setExcelSLoading, params: patamsmms, setDownLoadCondition: setDownLosadCondition }));
  }

  const HandleDownreportAgentTopLogs = () => {
    setDownLoadAgentCondition(false)
    setExcelAgentLoading(true)
    dispatch(ExportCampaignActivityReport({ setExcelLoading: setExcelAgentLoading, id: location?.state?.id, params, setDownLoadCondition: setDownLoadAgentCondition }));
  }

  useEffect(() => {
    if (statsactstatsrepdownconditions && statscallactivitydata) {
      exportExcelByActvityStatsOne();
    }
  }, [statsactstatsrepdownconditions, statscallactivitydata]);

  useEffect(() => {
    if (downloadsCond && Array.isArray(allActivitiesstatslogs) && allActivitiesstatslogs?.length !== 0) {
      exportLExcel();
    }
  }, [downloadsCond, allActivitiesstatslogs])

  useEffect(() => {
    if (downloadagentCond && Array.isArray(campaignActExpData?.data) && campaignActExpData?.data?.length !== 0) {
      exportExcel();
    }
  }, [downloadagentCond, campaignActExpData])

  useEffect(() => {
    const callingTimes = alldataactnote?.leads?.flatMap((lead) =>
      lead?.activities?.flatMap((activity) =>
        activity?.call_logs_activity
          ?.filter(log => log.call_status === "Calling")
          ?.map(log => log.call_started_on)
      )
    );

  }, [alldataactnote]);

  return (
    <>
      <div className="mb-4">
        <MainCard>
          <div style={{ display: "flex" }}>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                  }}
                >
                  {location.state?.name}
                </span>
                <p
                  style={{
                    fontSize: "10px",
                    padding: "0px",
                    margin: "0px",
                    marginLeft: "4px",
                  }}
                >
                  {location.state?.start_date}
                </p>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="flex-end">
              <div
                style={{ display: "flex", justifyContent: "right", padding: "10px" }}
              >
                <Button
                  disableElevation
                  className="px-2"
                  size="large"
                  type="submit"
                  onClick={HandleDownreportTopLogs}
                >
                  {excelSLoading ? <span>Exporting...</span> : <> <span className="mx-2">
                    <CiExport color="#0055A2" size={26} />
                  </span>
                    Activities Stats Report</>}
                </Button>
              </div>
              <div
                style={{ display: "flex", justifyContent: "right", padding: "10px" }}
              >
                <Button
                  disableElevation
                  className="px-2"
                  size="large"
                  type="submit"
                  onClick={HandleDownreportAgentTopLogs}
                >
                  {excelAgentLsoading ? <span>Exporting...</span> : <> <span className="mx-2">
                    <CiExport color="#0055A2" size={26} />
                  </span>
                    Agent Stats Campaign</>}
                </Button>
              </div>
              <Grid item>
                {can_add_activities ? <AddActivityDrawerRight data={location?.state}>
                  <Button
                    disableElevation
                    className="px-2"
                    size="large"
                    type="submit"
                  >
                    <span className="mx-2">
                      <IoMdAddCircle color="#0055A2" size={26} />
                    </span>
                    Add Activity
                  </Button>
                </AddActivityDrawerRight> : <></>}
              </Grid>
            </Grid>
          </div>
        </MainCard>
      </div>

      <>
        <MainCard>
          {can_view_activities ? (
            <Spin spinning={loading}>
              <Table
                className="border rounded"
                style={{ marginTop: 25 }}
                dataSource={allActivities?.campaings_activities ?? []}
                columns={columns}
              />
            </Spin>
          ) : null}
        </MainCard>
      </>
      <Modal
        title="Basic Modal"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <CsvUploadByofllineCall
          setDataSource={setDataSource}
        />

      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allActivities: state?.CampaignAllActivitiesRedc?.campaignAllActivities,
    campaignActExpData: state?.CampActivtyExportdataaRedc?.campaignActExpData,
    allActivitiesstatslogs: state?.AllLogsActivitiesStats?.allActivitiesstatslogs,
    alldataactnote: state?.AllReducerActivityReport?.alldataactnote,
    statscallactivitydata: state?.GetCallStatsReportBy?.statscallactivitydata,
  };
};

export default connect(mapStateToProps)(AllCampaigns);
